(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    const bar = document.querySelector('[data-sticky-buy-bar]');
    const target = document.querySelector('.pdp-main');
    if (!bar || !target || typeof IntersectionObserver === 'undefined') return;
    if (bar.dataset.stickyReady === 'true') return;
    bar.dataset.stickyReady = 'true';

    const button = bar.querySelector('.pdp-sticky-buy__button');

    const setVisible = function (visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) {
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('inert', '');
      }
    };

    const observer = new IntersectionObserver(function (entries) {
      const entry = entries[0];
      if (!entry) return;
      const aboveViewport = entry.boundingClientRect.top < 0;
      setVisible(!entry.isIntersecting && aboveViewport);
    });

    observer.observe(target);

    if (!button) return;

    button.addEventListener('click', function () {
      const buyBox = document.querySelector('.pdp-main__buy, .product__info-wrapper, .product-form');
      if (!buyBox) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      buyBox.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const checkout = document.querySelector('.pdp-main__checkout, .product-form__submit');
      if (!checkout) return;

      const focusCheckout = function () {
        checkout.focus({ preventScroll: true });
      };

      if (reduceMotion || !('onscrollend' in window)) {
        focusCheckout();
        return;
      }

      document.addEventListener('scrollend', focusCheckout, { once: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
